/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.15",
    versionName: "0.2.0-nightly.2026.2.15",
    versionChannel: "nightly",
    buildDate: "2026-02-15T00:10:02.017Z",
    commitHash: "30bbda7f9d9fddbac1b5451ae63c4200f742a95b",
};
